<template>
  <layout-main-inner title="退货管理">
    <layout-card-wrap v-loading="loading">
      <el-form @submit.native.prevent
               label-width="90px"
               label-position="left">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="退货类型：">
              <el-select @change="fetchList"
                         style="width: 100%"
                         v-model="config.ownerRange"
                         placeholder="请选择退货类型">
                <el-option v-for="item in ownerRange"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="退货日期：">
              <el-date-picker v-model="config.time"
                              :editable="false"
                              unlink-panels
                              style="width: 100%;"
                              type="daterange"
                              range-separator="-"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退货单号：">
              <el-input placeholder="请输入退货单号"
                        style="width: 100%"
                        v-model="config.goodsReturnCode">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标签序号：">
              <el-input placeholder="请输入标签序号"
                        style="width: 100%"
                        v-model.number="config.tagNo">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="选择商品：">
              <ent-product-auto-select style="width: 100%"
                                       v-model="config.productId" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退货客户：">
              <ent-delivery-auto-select style="width: 100%"
                                        v-model="config.deliveryAddressId" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button type="primary"
                         @click="handleCurrentChange(1)">查询</el-button>
              <el-button type="primary"
                         @click="downloadList">下载</el-button>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <!-- <template slot="form">
        <el-radio-group style="margin-right: 10px;"
                        v-model="config.ownerRange"
                        @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">企业退货</el-radio-button>
          <el-radio-button :label="0">客户退货</el-radio-button>
        </el-radio-group>
        <el-input placeholder="请输入退货单号"
                  v-model="config.goodsReturnCode"
                  style="width: 200px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template> -->
      <el-table border
                :data="list">
        <el-table-column label="退货单号"
                         fixed="left"
                         width="160">
          <template slot-scope="{row}">
            <!-- <link-route :link-to="`/goodsreturn-detail?vendorId=${row.vendorId}&goodsReturnId=${row.goodsReturnId}`">
              {{row.goodsReturnCode}}
            </link-route> -->
            {{row.goodsReturnCode}}
          </template>
        </el-table-column>
        <el-table-column label="商品名称"
                         min-width="300"
                         prop="productNames"></el-table-column>
        <el-table-column label="商品数"
                         min-width="80"
                         prop="returnGoodsCount"></el-table-column>
        <el-table-column label="订单号"
                         min-width="150"
                         prop="orderNumber"></el-table-column>
        <el-table-column label="退货信息"
                         prop="outGoodsCount"
                         min-width="280">
          <template slot-scope="{row}">
            <!-- <div>客户名称：{{row.dealerName}}</div>
            <div>退货方：{{row.deliveryName}}-{{row.deliveryPhone  }}</div> -->
            <div>单据归属：{{row.ownerName}}</div>
            <!-- <div>收货客户：</div> -->
            <div>退货客户：{{row.dealerName}}
              <template>-{{row.deliveryName}}</template>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="退货时间"
                         min-width="140">
          <template slot-scope="{row}">
            {{ row.goodsReturnTime | dateformat()}}
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         min-width="80">
          <template slot-scope="{row}">
            {{ row.status === 0 ? '草稿': '已退货'}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         width="90">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="viewDetail(row)">明细</el-button>
            <el-button type="text"
                       v-if="row.hasTag === 1"
                       @click="downloadreturntags(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <product-count-modal ref="modal" />
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import ProductCountModal from '../outstock/busi/product-count-modal.vue'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import EntDeliveryAutoSelect from '@/components/business/ent-delivery-auto-select.vue'
import Goodsreturn from '@/service/goodsreturn'
import { downloadBlobFile } from '@/utils/index'
import { getTimeRange } from '@/utils/formatTime'
export default {
  name: 'goodsreturn-list',
  components: { ProductCountModal, EntProductAutoSelect, EntDeliveryAutoSelect },
  data () {
    return {
      loading: false,
      config: { ownerRange: null, pageNum: 1, pageSize: 10, goodsReturnCode: '', vendorId: null, tagNo: '', productId: null, deliveryAddressId: null, time: null },
      list: [],
      total: 0,
      ownerRange: [
        { label: '全部退货', value: null },
        { label: '客户退货', value: 0 },
        { label: '企业退货', value: 1 }
      ]
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    getquery () {
      const [beginTime, endTime, time] = getTimeRange(this.config.time)
      return { ...this.config, beginTime, endTime, time }
    },
    downloadList () {
      this.loading = true
      Goodsreturn.downloadgoodsreturns({ ...this.getquery() })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('goodsreturn/getgoodsreturns', {
        payload: { ...this.getquery() },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    downloadreturntags (row) {
      this.loading = true
      this.$store.dispatch('goodsreturn/downloadreturntags', {
        payload: { goodsReturnId: row.goodsReturnId, vendorId: row.vendorId },
        success: (res) => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    viewDetail (row) {
      console.log(row)
      this.$refs.modal.searchGoodsreturn(row, '退货商品明细')
    }
  },
  created () {
    if (this.query) {
      this.config = { ...this.config, ...this.query }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus"></style>
